import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../..';
import snackbarStore from "../../../../snackbarStore";
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import { CUSTOM } from "../../../sc-utilities/snackbar/store/actionTypes";
import config  from '../../../../config/config';
import { download } from '../../../sc-utilities/download.utils';

export const setLastSearchData = (data) => {
    return ({
        type: 'HANDLE_SEARCH_SET',
        search: data
    });
};

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'search',
    pluginName: 'SEARCH',
    entityName: 'SEARCH',
    fetchSuccessMessage: ''
});

// Fetch Search action creators
export const fetchSearchInit = () => {
    return crudActions.fetchInit();
};
export const fetchSearchStart = () => {
    return crudActions.fetchStart();
};
export const fetchSearchSuccess = (fetchSearchCount, listSearchCount) => {
    return crudActions.fetchSuccess(fetchSearchCount, listSearchCount);
};
export const fetchSearchFail = () => {
    return crudActions.fetchFail();
};

export const fetchSearch = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSearchStart());
        try {
            let listRes = await rest.post("/search/all", filterData);
            const {ActiveCustomerID, Token, ...searchParams} = filterData;
            if (listRes.data && listRes.data.succeeded) {
                delete searchParams.query;
                dispatch(setLastSearchData({ lastSearchParams: searchParams }));
                dispatch(fetchSearchSuccess(listRes.data.result.data.length, listRes.data.result.data));
                return { data: listRes.data.result.data, count: listRes.data.result.data.length };
            }
            dispatch(fetchSearchFail());
            snackActions.snackBar({
                message: `${listRes && listRes.data ? listRes.data.message : "Cannot fetch search."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: [], count: 0 };
        } catch (error) {
            dispatch(fetchSearchFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch search."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 };
        }
    };
};

export const ClearStateCreate = () => {
    return ({
        type: 'CLEAR_STATE_SEARCH'
    });
};

export const exportSearchData = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            params['SocketID'] = socket.id.split('#')[1];
            let res = await rest.post('/report/create-collection', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const responseParams = res.data.result.data;
                const redisTopic = responseParams.RedisTopic;
                if (responseParams.AutoDownloadEnabled) {
                    socket.on(redisTopic, async msg => {
                        const { Status, ErasureReportID, RedisTopic } = msg;
                        const { Generated, ToGenerate, Message } = msg;
                        snackbarStore.dispatch(snackbarActions.showCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                        if (Status === 'error') {
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            return snackActions.snackBar({
                                message: Message || `Error: Create collection failed. Please contact administrator.`,
                                options: {
                                    variant: 'error'
                                }
                            });
                        }

                        if (Status === 'generated') {
                            const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${params.ActiveCustomerID}`;
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            await download(objUrl);
                            snackActions.snackBar({
                                message: `Create collection finished.`,
                                options: {
                                    variant: 'success'
                                }
                            });
                        }

                    });
                }

            } else {
                snackActions.snackBar({
                    message: `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}